import React, {useEffect, useRef, useState} from "react";
import {Link, useLocation} from 'react-router-dom';
import newLogo_300 from '../images/newlogo-300x131.png';

const NAV_LINKS = [
	{to: '/', label: 'Ana Sayfa'},
	{to: '/hizmetlerimiz', label: 'Hizmetlerimiz'},
	{to: '/referanslarimiz', label: 'Referanslarımız'},
	{to: '/iletisim', label: 'İletişim'},
];

const Header = () => {
	const drawerRef = useRef(null);
	const headerRef = useRef(null);
	const [isOpen, setIsOpen] = useState(false);
	const {pathname} = useLocation();

	useEffect(() => {
		const onScroll = () => {
			if (!headerRef.current) return;
			headerRef.current.classList.toggle('is-scrolled', window.scrollY > 8);
		};
		onScroll();
		window.addEventListener('scroll', onScroll, {passive: true});
		return () => window.removeEventListener('scroll', onScroll);
	}, []);

	useEffect(() => {
		document.body.style.overflow = isOpen ? 'hidden' : '';
		return () => {
			document.body.style.overflow = '';
		};
	}, [isOpen]);

	useEffect(() => {
		setIsOpen(false);
	}, [pathname]);

	return (
		<>
			<header className='header' ref={headerRef}>
				<div className='inner-header'>
					<Link to='/' aria-label='Proteam Yönetim — Ana Sayfa'>
						<img src={newLogo_300} alt='Proteam Yönetim'/>
					</Link>
					<nav>
						<ul className='links'>
							{NAV_LINKS.map((link) => (
								<li key={link.to}>
									<Link
										to={link.to}
										className={pathname === link.to ? 'active' : ''}
									>
										{link.label}
									</Link>
								</li>
							))}
							<li
								className='burger'
								onClick={() => setIsOpen(true)}
								role='button'
								aria-label='Menüyü aç'
								tabIndex={0}
								onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && setIsOpen(true)}
							>
								<i className='fa fa-bars'></i>
							</li>
						</ul>
					</nav>
				</div>
			</header>
			<div
				className={`responsive-header ${isOpen ? 'active' : ''}`}
				ref={drawerRef}
			>
				<div
					className='close'
					onClick={() => setIsOpen(false)}
					role='button'
					aria-label='Menüyü kapat'
					tabIndex={0}
					onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && setIsOpen(false)}
				>
					×
				</div>
				<nav>
					<ul className='links'>
						{NAV_LINKS.map((link) => (
							<li key={link.to} onClick={() => setIsOpen(false)}>
								<Link
									to={link.to}
									className={pathname === link.to ? 'active' : ''}
								>
									{link.label}
								</Link>
							</li>
						))}
					</ul>
				</nav>
			</div>
		</>
	);
};

export default Header;
